module.exports = __webpack_public_path__ + "img/flow.cbcaaa50.png";